import { roleStore } from "../stores/roleStore";
import "../stores/toastStore";
import { USER_ROLE } from "../types/UserRole";
export function setRole() {
    if (typeof window === "undefined")
        return;
    const hash = window.location.hash;
    const queryString = hash.includes("?") ? hash.split("?")[1] : "";
    const params = new URLSearchParams(queryString);
    const roleParam = params.get("role");
    console.log('[setRole] roleParam', roleParam);
    if (roleParam === USER_ROLE.CLIENT || roleParam === USER_ROLE.EXPERT) {
        roleStore.set(roleParam);
    }
    else {
        roleStore.set(USER_ROLE.CLIENT);
    }
}
